module.exports = __webpack_public_path__ + "img/0-72.ec311989.jpg";